import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ContractError } from '@/components/widgets/contract-error/contract-error'
import { getContract } from '@/api/get-contract'

export const Route = createFileRoute('/contracts/$houseId/$flat')({
  component: Outlet,
  errorComponent: ContractError,
  loader: ({ params }) => getContract(params.houseId, params.flat),
  staleTime: 60 * 1000,
})
